import { EditorState } from "@codemirror/state"
import { matchBrackets } from "@codemirror/language"

const OPENING_BRACKETS = new Set(["(", "[", "{"])
const CLOSING_BRACKETS = new Set([")", "]", "}"])
const ALL_BRACKETS = new Set([...OPENING_BRACKETS, ...CLOSING_BRACKETS])

export function findMatchingBracket(state: EditorState, pos: number, char: string) {
  // Early return if not a bracket
  if (!ALL_BRACKETS.has(char)) {
    return null
  }

  const isOpenBracket = OPENING_BRACKETS.has(char)

  // For closing brackets, CodeMirror expects position after the bracket
  const position = isOpenBracket ? pos : pos + 1
  const direction = isOpenBracket ? 1 : -1
  const match = matchBrackets(state, position, direction)

  if (!match?.matched) {
    return null
  }

  return match
}
